'use client';

import utilsStyles from '@/styles/modules/utils.module.scss';
import { formatCurrency } from '@monorepo/common';
import { useTranslation } from 'react-i18next';
import type { LotteryPrice } from '../../types';
import styles from './ShippingAlert.module.scss';

function ShippingAlert({
  price,
  additionalShippingFeePerTimes,
}: {
  price: LotteryPrice;
  additionalShippingFeePerTimes?: number;
}) {
  const { t } = useTranslation();

  return (
    <div className={`${styles.shippingAlert} ${utilsStyles.textSmall}`}>
      <span>{message(price, t, additionalShippingFeePerTimes)}</span>
    </div>
  );
}

function message(
  price: LotteryPrice,
  t: (key: string, options?: Record<string, string | number | undefined>) => string,
  additionalShippingFeePerTimes?: number,
) {
  if (price.additionalShippingFee > 0 && price.shippingFee > 0) {
    return t('shippingFee.bothFees', {
      firstFee: formatCurrency(price.shippingFee),
      interval: additionalShippingFeePerTimes,
      additionalFee: formatCurrency(price.additionalShippingFee),
    });
  }
  if (price.additionalShippingFee > 0) {
    return t('shippingFee.additionalOnly', {
      interval: additionalShippingFeePerTimes,
      additionalFee: formatCurrency(price.additionalShippingFee),
    });
  }
  return t('shippingFee.firstTimeOnly', { firstFee: formatCurrency(price.shippingFee) });
}

export default ShippingAlert;
